import { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator
} from '@/components/ui/dropdown-menu';
import {
  Handshake,
  LayoutDashboard, Users, BookOpen, Dumbbell, ClipboardCheck, CreditCard,
  UserPlus, AlertTriangle, LogOut, Menu, User, ChevronRight, DollarSign,
  Receipt, Wallet, BarChart3, Settings, Key, Package, ShoppingBag, ShoppingCart, UserCircle, Trophy, Medal, Tags, Megaphone
} from 'lucide-react';
import NotificationBell from '@/components/NotificationBell';

function getContrastColor(hex) {
  if (!hex || hex.length < 7) return '#ffffff';
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#ffffff';
}

const navConfig = {
  admin: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin' },
    { label: 'Gestores', icon: Users, path: '/admin/gestores' },
    { label: 'Planos Plataforma', icon: CreditCard, path: '/admin/planos' },
    { label: 'Financeiro', icon: DollarSign, path: '/admin/financeiro' },
    { section: 'CONFIG' },
    { label: 'Chave PIX', icon: Key, path: '/admin/config-pix' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/admin/perfil' },
  ],
  gestor: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/gestor' },
    { label: 'Alunos', icon: Users, path: '/gestor/alunos' },
    { label: 'Responsáveis', icon: Users, path: '/gestor/responsaveis' },
      { label: 'Categorias', icon: Tags, path: '/gestor/categorias' },
      { label: 'Pré-cadastros', icon: UserPlus, path: '/gestor/pre-cadastros' },
    { label: 'Turmas', icon: BookOpen, path: '/gestor/turmas' },
    { label: 'Treinos', icon: Dumbbell, path: '/gestor/treinos' },
    { label: 'Treino em Casa', icon: Dumbbell, path: '/gestor/treinos-casa' },
    { label: 'Seletivas', icon: ClipboardCheck, path: '/gestor/seletivas' },
    { label: 'Presença', icon: ClipboardCheck, path: '/gestor/presenca' },
    { label: 'Avisos', icon: Megaphone, path: '/gestor/avisos' },
    { label: 'Planos', icon: CreditCard, path: '/gestor/planos' },
    { label: 'Colaboradores', icon: UserPlus, path: '/gestor/colaboradores' },
    { section: 'FINANCEIRO' },
    { label: 'Dashboard Fin.', icon: BarChart3, path: '/gestor/financeiro' },
    { label: 'Recebimentos dos Sócios', icon: Wallet, path: '/gestor/recebimentos-socios' },
    { label: 'Parcerias', icon: Handshake, path: '/gestor/parcerias' },
    { label: 'Mensalidades', icon: Receipt, path: '/gestor/mensalidades' },
      { label: 'Contratos', icon: Receipt, path: '/gestor/contratos' },
    { label: 'Despesas', icon: DollarSign, path: '/gestor/despesas' },
    { label: 'Inadimplentes', icon: AlertTriangle, path: '/gestor/inadimplentes' },
    { label: 'Meu Plano', icon: Wallet, path: '/gestor/meu-financeiro' },
    { section: 'LOJA' },
    { label: 'Produtos', icon: Package, path: '/gestor/produtos' },
    { label: 'Pedidos', icon: ShoppingBag, path: '/gestor/pedidos' },
    { section: 'CONFIG' },
    { label: 'Configuracoes', icon: Settings, path: '/gestor/configuracoes' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/gestor/perfil' },
  ],
  socio: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/gestor' },
    { label: 'Alunos', icon: Users, path: '/gestor/alunos' },
      { label: 'Categorias', icon: Tags, path: '/gestor/categorias' },
      { label: 'Pré-cadastros', icon: UserPlus, path: '/gestor/pre-cadastros' },
    { label: 'Turmas', icon: BookOpen, path: '/gestor/turmas' },
    { label: 'Treinos', icon: Dumbbell, path: '/gestor/treinos' },
    { label: 'Treino em Casa', icon: Dumbbell, path: '/gestor/treinos-casa' },
    { label: 'Seletivas', icon: ClipboardCheck, path: '/gestor/seletivas' },
    { label: 'Presença', icon: ClipboardCheck, path: '/gestor/presenca' },
    { label: 'Avisos', icon: Megaphone, path: '/gestor/avisos' },
    { label: 'Planos', icon: CreditCard, path: '/gestor/planos' },
    { section: 'FINANCEIRO' },
    { label: 'Dashboard Fin.', icon: BarChart3, path: '/gestor/financeiro' },
    { label: 'Recebimentos dos Sócios', icon: Wallet, path: '/gestor/recebimentos-socios' },
    { label: 'Parcerias', icon: Handshake, path: '/gestor/parcerias' },
    { label: 'Mensalidades', icon: Receipt, path: '/gestor/mensalidades' },
      { label: 'Contratos', icon: Receipt, path: '/gestor/contratos' },
    { label: 'Despesas', icon: DollarSign, path: '/gestor/despesas' },
    { label: 'Inadimplentes', icon: AlertTriangle, path: '/gestor/inadimplentes' },
    { section: 'LOJA' },
    { label: 'Produtos', icon: Package, path: '/gestor/produtos' },
    { label: 'Pedidos', icon: ShoppingBag, path: '/gestor/pedidos' },
    { section: 'CONFIG' },
    { label: 'Configuracoes', icon: Settings, path: '/gestor/configuracoes' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/gestor/perfil' },
  ],
  professor: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/gestor' },
    { label: 'Alunos', icon: Users, path: '/gestor/alunos' },
      { label: 'Categorias', icon: Tags, path: '/gestor/categorias' },
    { label: 'Turmas', icon: BookOpen, path: '/gestor/turmas' },
    { label: 'Treinos', icon: Dumbbell, path: '/gestor/treinos' },
    { label: 'Treino em Casa', icon: Dumbbell, path: '/gestor/treinos-casa' },
    { label: 'Seletivas', icon: ClipboardCheck, path: '/gestor/seletivas' },
    { label: 'Presença', icon: ClipboardCheck, path: '/gestor/presenca' },
    { section: 'CONFIG' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/gestor/perfil' },
  ],
  professor_staff: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/gestor' },
    { label: 'Turmas', icon: BookOpen, path: '/gestor/turmas' },
    { label: 'Treinos', icon: Dumbbell, path: '/gestor/treinos' },
    { label: 'Treino em Casa', icon: Dumbbell, path: '/gestor/treinos-casa' },
    { label: 'Seletivas', icon: ClipboardCheck, path: '/gestor/seletivas' },
    { label: 'Presença', icon: ClipboardCheck, path: '/gestor/presenca' },
  ],

  financeiro: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/gestor' },
    { label: 'Alunos', icon: Users, path: '/gestor/alunos' },
      { label: 'Categorias', icon: Tags, path: '/gestor/categorias' },
    { label: 'Planos', icon: CreditCard, path: '/gestor/planos' },
    { section: 'FINANCEIRO' },
    { label: 'Dashboard Fin.', icon: BarChart3, path: '/gestor/financeiro' },
    { label: 'Mensalidades', icon: Receipt, path: '/gestor/mensalidades' },
      { label: 'Contratos', icon: Receipt, path: '/gestor/contratos' },
    { label: 'Inadimplentes', icon: AlertTriangle, path: '/gestor/inadimplentes' },
    { section: 'LOJA' },
    { label: 'Produtos', icon: Package, path: '/gestor/produtos' },
    { label: 'Pedidos', icon: ShoppingBag, path: '/gestor/pedidos' },
    { section: 'CONFIG' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/gestor/perfil' },
  ],
  parceiro: [
    { label: 'Turmas', icon: BookOpen, path: '/parceiro/turmas' },
    { label: 'Financeiro', icon: DollarSign, path: '/parceiro/financeiro' },
    { section: 'CONTA' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/parceiro/perfil' },
  ],
  responsavel: [
    { label: 'Meus Filhos', icon: Users, path: '/responsavel' },
    { section: 'CONTA' },
    { label: 'Alterar Senha', icon: Key, path: '/responsavel/alterar-senha' },
  ],
  aluno: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/aluno' },
    { label: 'Treinos', icon: Dumbbell, path: '/aluno/treinos' },
    { label: 'Ranking', icon: Trophy, path: '/aluno/ranking' },
    { label: 'Medalhas', icon: Medal, path: '/aluno/medalhas' },
    { label: 'Mensalidades', icon: CreditCard, path: '/aluno/mensalidades' },
    { section: 'LOJA' },
    { label: 'Loja', icon: ShoppingCart, path: '/aluno/loja' },
    { label: 'Meus Pedidos', icon: ShoppingBag, path: '/aluno/pedidos' },
    { section: 'FAMÍLIA' },
    { label: 'Meu Responsável', icon: UserCircle, path: '/aluno/responsavel' },
    { section: 'CONFIG' },
    { label: 'Meu Perfil', icon: UserCircle, path: '/aluno/perfil' },
  ],
};

function SidebarContent({ items, onNavigate, tenantConfig }) {
  return (
    <div className="flex flex-col h-full">
      <div className="p-5 border-b border-[#27272A]">
        {tenantConfig?.logo_url ? (
          <div className="flex items-center gap-2">
            <img src={tenantConfig.logo_url} alt="Logo" className="h-8 object-contain" onError={(e) => e.target.style.display = 'none'} />
            <h1 className="text-lg font-black tracking-tighter font-['Barlow_Condensed'] text-white uppercase truncate">
              {tenantConfig.nome_escola || 'SportManager'}
            </h1>
          </div>
        ) : (
          <h1 className="text-xl font-black tracking-tighter font-['Barlow_Condensed'] text-white uppercase">
            {tenantConfig?.nome_escola || <>Sport<span style={{ color: 'var(--cor-primaria, #007AFF)' }}>Manager</span></>}
          </h1>
        )}
      </div>
      <ScrollArea className="flex-1 py-3">
        <nav className="px-3 space-y-1">
          {items.map((item, idx) => {
            if (item.section) {
              return (
                <div key={`section-${idx}`} className="pt-4 pb-1 px-3">
                  <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-600">{item.section}</p>
                </div>
              );
            }
            const basePath = item.path.split('/').slice(0, 2).join('/');
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/admin' || item.path === '/gestor' || item.path === '/aluno' || item.path === '/parceiro' || item.path === '/responsavel'}
                onClick={onNavigate}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group ${
                    isActive
                      ? 'text-white border-l-2 ml-0'
                      : 'text-zinc-400 hover:text-white hover:bg-[#1C1C1E]'
                  }`
                }
                style={({ isActive }) => isActive ? { backgroundColor: 'color-mix(in srgb, var(--cor-primaria, #007AFF) 15%, transparent)', borderColor: 'var(--cor-primaria, #007AFF)' } : {}}
                data-testid={`nav-${item.label.toLowerCase().replace(/[\s.]+/g, '-')}`}
              >
                <item.icon className="w-4 h-4 shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </ScrollArea>
    </div>
  );
}

export default function DashboardLayout() {

  const {

    user,

    logout,

    effectiveRole,

    staffPortalMode,

    setStaffPortalMode

  } = useAuth();


  const location = useLocation();

  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);


  const isStaffProfessor =

    user?.role === 'aluno' &&

    user?.acesso_staff === true &&

    effectiveRole === 'professor_staff';


  const switchStaffPortal = () => {

    if (user?.role !== 'aluno' || user?.acesso_staff !== true) return;


    if (isStaffProfessor) {

      setStaffPortalMode('aluno');

      navigate('/aluno');

    } else {

      setStaffPortalMode('professor');

      navigate('/gestor');

    }

  };
  const [tenantConfig, setTenantConfig] = useState(null);

  useEffect(() => {
    if (user?.role === 'admin') return;
    const prefix =
      effectiveRole === 'professor_staff'
        ? '/gestor'
        : user?.role === 'aluno'
          ? '/aluno'
          : user?.role === 'responsavel'
            ? '/responsavel'
            : '/gestor';
    api.get(`${prefix}/config-visual`)
      .then(r => {
        setTenantConfig(r.data);
        const root = document.documentElement;
        const pri = r.data.cor_primaria || '#007AFF';
        const sec = r.data.cor_secundaria || '#FF3B30';
        root.style.setProperty('--cor-primaria', pri);
        root.style.setProperty('--cor-secundaria', sec);
        // Auto-contrast: calculate text color based on luminance
        root.style.setProperty('--cor-primaria-text', getContrastColor(pri));
        root.style.setProperty('--cor-secundaria-text', getContrastColor(sec));
      })
      .catch(() => {});
  }, [user?.role, effectiveRole]);

  const navRole =
    effectiveRole === 'professor_staff'
      ? 'professor_staff'
      : user?.role;

  const items = navConfig[navRole] || [];

  const flatItems = items.filter(i => !i.section);
  const currentPage = flatItems.find(i => location.pathname === i.path)?.label || 'Dashboard';

  // A Área do Aluno possui identidade visual própria.
  // STAFF em modo professor continua usando o layout administrativo.
  const isAlunoPortal =
    user?.role === 'aluno' &&
    effectiveRole !== 'professor_staff';

  const roleLabel = {
    admin: 'Administrador',
    gestor: 'Gestor',
      socio: 'Sócio',
    professor: 'Professor',
    professor_staff: 'Professor',
    financeiro: 'Financeiro',
    parceiro: 'Parceiro',
    aluno: 'Aluno',
    responsavel: 'Responsável',
  };

  return (
    <div
      className={`flex h-screen ${
        isAlunoPortal
          ? 'bg-[#09090B]'
          : 'bg-[#0A0A0A]'
      }`}
      data-testid="dashboard-layout"
    >
      {/* Desktop Sidebar */}
      <aside
        className={`hidden lg:flex flex-col shrink-0 ${
          isAlunoPortal
            ? 'lg:w-[248px] bg-[#0C0C0F] border-r border-white/[0.06]'
            : 'lg:w-[260px] bg-[#0A0A0A] border-r border-[#27272A]'
        }`}
      >
        <SidebarContent
          items={items}
          onNavigate={() => {}}
          tenantConfig={tenantConfig}
        />
      </aside>

      {/* Mobile Sidebar — mantido para portais administrativos */}
      {!isAlunoPortal && (
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" className="w-[260px] p-0 bg-[#0A0A0A] border-[#27272A]">
            <SidebarContent items={items} onNavigate={() => setMobileOpen(false)} tenantConfig={tenantConfig} />
          </SheetContent>
        </Sheet>
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header
          className={`flex items-center justify-between px-4 lg:px-6 shrink-0 ${
            isAlunoPortal
              ? 'h-16 border-b border-white/[0.06] bg-[#0C0C0F]/95 backdrop-blur-xl'
              : 'h-14 border-b border-[#27272A] bg-[#0A0A0A]'
          }`}
        >
          <div className="flex items-center gap-3">
            {!isAlunoPortal && (
              <Button
                variant="ghost"
                size="icon"
                className="lg:hidden text-zinc-400 hover:text-white"
                onClick={() => setMobileOpen(true)}
                data-testid="mobile-menu-button"
              >
                <Menu className="w-5 h-5" />
              </Button>
            )}
            {isAlunoPortal ? (
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-[0.22em] font-bold text-zinc-600">
                  Área do atleta
                </p>
                <p className="text-sm font-semibold text-white truncate">
                  {currentPage}
                </p>
              </div>
            ) : (
              <div className="flex items-center gap-2 text-sm text-zinc-400">
                <span className="hidden sm:inline">{roleLabel[navRole] || 'Sistema'}</span>
                <ChevronRight className="w-3 h-3 hidden sm:inline" />
                <span className="text-white font-medium">{currentPage}</span>
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <NotificationBell />

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  className="gap-2 text-zinc-400 hover:text-white"
                  data-testid="user-menu-button"
                >
                  <div
                    className={`rounded-full flex items-center justify-center overflow-hidden ${
                      isAlunoPortal ? 'w-9 h-9' : 'w-7 h-7'
                    }`}
                    style={{
                      backgroundColor:
                        'color-mix(in srgb, var(--cor-primaria, #007AFF) 18%, transparent)'
                    }}
                  >
                    {user?.avatar_url ? (
                      <img src={user.avatar_url} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <User
                        className="w-4 h-4"
                        style={{ color: 'var(--cor-primaria, #007AFF)' }}
                      />
                    )}
                  </div>
                  <span className="hidden sm:inline text-sm">{user?.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48 bg-[#141414] border-[#27272A]">
                <div className="px-2 py-1.5">
                  <p className="text-sm font-medium text-white">{user?.name}</p>
                  <p className="text-xs text-zinc-500">{user?.email}</p>
                </div>
                <DropdownMenuSeparator className="bg-[#27272A]" />

                {user?.role === 'aluno' && user?.acesso_staff === true && (
                  <>
                    <DropdownMenuItem
                      onClick={switchStaffPortal}
                      className="text-zinc-200 focus:text-white focus:bg-[#1C1C1E] cursor-pointer"
                      data-testid="staff-switch-area"
                    >
                      <UserCircle className="w-4 h-4 mr-2" />
                      {staffPortalMode === 'professor'
                        ? 'Voltar para Área do Aluno'
                        : 'Entrar na Área do Professor'}
                    </DropdownMenuItem>

                    <DropdownMenuSeparator className="bg-[#27272A]" />
                  </>
                )}

                <DropdownMenuItem
                  onClick={logout}
                  className="text-red-400 focus:text-red-400 focus:bg-red-500/10 cursor-pointer"
                  data-testid="logout-button"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>

        {/* Page content */}
        <main
          className={`flex-1 overflow-auto ${
            isAlunoPortal
              ? 'px-4 pt-5 pb-24 sm:px-6 lg:px-8 lg:py-7'
              : 'p-4 lg:p-6'
          }`}
        >
          {isAlunoPortal ? (
            <div className="w-full max-w-[1440px] mx-auto">
              <Outlet />
            </div>
          ) : (
            <Outlet />
          )}
        </main>

        {/* Navegação inferior — exclusiva da Área do Aluno no mobile */}
        {isAlunoPortal && (
          <nav
            className="lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-white/[0.08] bg-[#0C0C0F]/95 backdrop-blur-xl"
            data-testid="aluno-bottom-nav"
          >
            <div className="grid grid-cols-5 h-[68px] px-1">
              {[
                { label: 'Início', path: '/aluno', icon: LayoutDashboard },
                { label: 'Treinos', path: '/aluno/treinos', icon: Dumbbell },
                { label: 'Em Casa', path: '/aluno/treinos-casa', icon: Dumbbell },
                { label: 'Ranking', path: '/aluno/ranking', icon: Trophy },
                { label: 'Perfil', path: '/aluno/perfil', icon: UserCircle }
              ].map((item) => {
                const Icon = item.icon;
                const active =
                  item.path === '/aluno'
                    ? location.pathname === '/aluno'
                    : item.path === '/aluno/treinos-casa'
                      ? location.pathname.startsWith('/aluno/treinos-casa')
                      : location.pathname === item.path;

                return (
                  <button
                    key={item.path}
                    type="button"
                    onClick={() => navigate(item.path)}
                    className={`relative flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
                      active ? 'text-white' : 'text-zinc-500'
                    }`}
                  >
                    {active && (
                      <span
                        className="absolute top-0 w-8 h-0.5 rounded-full"
                        style={{ backgroundColor: 'var(--cor-primaria, #007AFF)' }}
                      />
                    )}

                    <Icon
                      className="w-5 h-5"
                      style={
                        active
                          ? { color: 'var(--cor-primaria, #007AFF)' }
                          : undefined
                      }
                    />

                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </nav>
        )}
      </div>
    </div>
  );
}
